export const logout = () => {
    console.error("Authentication error: Token is invalid or expired. Logging out.");
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser'); // Also remove the user data
    window.location.href = '/'; // Redirect to the root, which will then show the login page
};
/**
 * A smart wrapper for the native fetch API.
 * It automatically adds the Authorization header and handles 401 errors globally.
 */
export const fetchWithAuth = async (url, options = {}) => {
    const token = localStorage.getItem('adminToken');
    const headers = { 'Content-Type': 'application/json', ...options.headers };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
        logout(); // Force logout on authentication failure
        throw new Error('Your session has expired. Please log in again.');
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'An unknown server error' }));
        throw new Error(errorData.error || `HTTP error! Status: ${response.status}`);
    }

    return response.json();
};